import { render, staticRenderFns } from "./RegistrarObra.vue?vue&type=template&id=718904e6&"
import script from "./RegistrarObra.vue?vue&type=script&lang=js&"
export * from "./RegistrarObra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports